import type { FunctionComponent } from 'react';

/**
 * Generic FOSSA Monospace text, wrapped in a <code> tag.
 *
 * @param {React.ReactNode} children - The text to display
 */
const Monospace: FunctionComponent = ({ children }) => (
  <code className="fossa-text fossa-text__monospace">
    {children}
  </code>
);

export default Monospace;
